import {useContext} from 'react'

import PropTypes from 'prop-types'

import Context from '@s-ui/react-context'
import {Badge, BADGE_DESIGNS, BADGE_INTENTS, BADGE_SIZES} from '@adv-mt/ui/badge'
import {Button, BUTTON_VARIANTS} from '@adv-mt/ui/button'
import {Headline2} from '@adv-mt/ui/typography'

import {BASE_CLASS} from './config.js'

const MAX_VISIBLE = 6
const MAX_SINGLE_LINE_CHARS = 30

const IncludedExtras = ({onShowAll, optionalEquipment = []}) => {
  const {i18n} = useContext(Context)

  const allItems = optionalEquipment.flatMap(group =>
    (group.descriptions || []).map(d => (typeof d === 'string' ? d : d.value))
  )

  if (!allItems.length) return null

  const hasMore = allItems.length > MAX_VISIBLE
  const visibleItems = allItems.slice(0, MAX_VISIBLE)
  const extraCount = allItems.length - MAX_VISIBLE

  return (
    <div className={[`${BASE_CLASS}-extras`, !hasMore && `${BASE_CLASS}-extras--compact`].filter(Boolean).join(' ')}>
      <div className={`${BASE_CLASS}-extrasHeader`}>
        <Headline2 as="h3" className={`${BASE_CLASS}-extrasTitle`}>
          {i18n.t('COMMON.DETAIL_EXTRAS_INCLUDED')}
        </Headline2>
        {hasMore && (
          <Button
            className={`${BASE_CLASS}-extrasShowAll ${BASE_CLASS}-extrasShowAll--desktop`}
            onClick={onShowAll}
            variant={BUTTON_VARIANTS.LINK}
          >
            {i18n.t('COMMON.SHOW_ALL')}
          </Button>
        )}
      </div>
      <ul className={`${BASE_CLASS}-extrasBadges`}>
        {visibleItems.map((item, index) => (
          <li
            key={index}
            className={[
              `${BASE_CLASS}-extrasBadgeWrapper`,
              item.length > MAX_SINGLE_LINE_CHARS && `${BASE_CLASS}-extrasBadgeWrapper--multiline`
            ]
              .filter(Boolean)
              .join(' ')}
          >
            <Badge design={BADGE_DESIGNS.SOLID} intent={BADGE_INTENTS.SURFACE} size={BADGE_SIZES.LARGE}>
              {item.length > MAX_SINGLE_LINE_CHARS ? (
                <span className={`${BASE_CLASS}-extrasBadgeText`}>{item}</span>
              ) : (
                item
              )}
            </Badge>
          </li>
        ))}
        {extraCount > 0 && (
          <li className={`${BASE_CLASS}-extrasBadgeWrapper`}>
            <Badge design={BADGE_DESIGNS.SOLID} intent={BADGE_INTENTS.SURFACE} size={BADGE_SIZES.LARGE}>
              {`+${extraCount}`}
            </Badge>
          </li>
        )}
      </ul>
      {hasMore && (
        <Button
          className={`${BASE_CLASS}-extrasShowAll ${BASE_CLASS}-extrasShowAll--mobile`}
          onClick={onShowAll}
          variant={BUTTON_VARIANTS.LINK}
        >
          {i18n.t('COMMON.SHOW_ALL')}
        </Button>
      )}
    </div>
  )
}

IncludedExtras.displayName = 'IncludedExtras'
IncludedExtras.propTypes = {
  onShowAll: PropTypes.func,
  optionalEquipment: PropTypes.array
}

export default IncludedExtras
